// This file is automatically @generated by scripts/generate-json-schema/index.ts

export const sessionStorageVersions: { readonly [key: string]: string } = {
  academyCategories: 'fb670d0a0bce7a40e6d3e1866599b496',
  academyCourses: 'daa590ef35214f5e040f2bd6ee34412a',
  academyInstructors: '6f4a29e8301b4de6ba957be8a227331b',
  academyLessons: 'def9dd292a20a515a8e833080e617979',
  academyModules: 'db5a8b4e3d5d31db4f7706783b6e3d40',
  academyPriceTiers: '8f9b15b484a31e0d60ea7001b3c61961',
  accountProgress: '3688d6e7dc0acbb3fa916977d4639d93',
  agentSessions: '33cd2c64dafbae9a9d94f85febee0490',
  agents: 'da6a4370f1cfadfa614a982059930e6c',
  allProjects: 'ef74c3725e6f4b3c58423b07a6b716f4',
  applicationScopes: '9947a1a7d3aef85aebd2999eac5c31b8',
  articles: '21e2a589930880b02849c0d5cd1784c6',
  banners: 'd6eb341a552a2b58eb00035aa63d38b6',
  bidAwardDrafts: '4bdb7e717a8ce7e339b808ccfcc39e7b',
  bidAwardRevokeReasons: '64acf7c4c868f9dbcb96f165f6152f33',
  bidBuyerProjectFees: '1fe413c25bf07f0f2c6c9a525a43b20d',
  bidEditRequests: '3adb4df25e6f2abbe24ddd9c4782d4a4',
  bidRestrictions: 'ae3f72bccd6d6dd055c5c79b6da3e2b1',
  bidSummaries: '7d5ace0b55b64e31fa94713422e25ab0',
  bidUpgradeFees: '4579a27fe5872b4df1b9cf24f9c53d57',
  bids: 'acb50dcac2299e47945d9a727bac1026',
  billingAgreements: '3c4c53d4e27f4fda22b62c242e26b1e4',
  canViewEmployerProfile: 'e4cd062351bbdf3e5ac60870fc756d88',
  cartItems: '2d44af47e78ebcbeea7d4a3dc3499e5b',
  carts: '22516f581ba71b60c5e67a3870e4eb2b',
  categoryPageContent: 'eb8dc5f473e7c3d5509538e7b6d290fb',
  categoryPageViewUsers: 'b29322c6d0c57c0c1bc9acbca6ee4f3e',
  certifications: '43fd8862311f73a91a22f2e897799065',
  commentFeeds: '876eb0b131b434e4da96680774124041',
  comments: '97af2b2cff5abda721918679ee02d12e',
  contacts: 'be91ea1ae927f72bbd248679462f710a',
  contestBudgetRanges: '68ec769e2457359239fdcc61ad36f041',
  contestComments: 'f7c0d794e15afbe67510057bab896401',
  contestEngagement: 'a5593474fb4fe13cf7ff54a2b5dcacda',
  contestEntries: '51d116218f1a7f0dc626ec43adf4e1c7',
  contestEntryMessages: '51738e8f459dbdde3c0a3d64c49d4ca5',
  contestEntryOffers: '4b2413d572e0f8f8b616258e6ac8cc22',
  contestFees: '12a03576c5a766a03818e2a660483e90',
  contestFiles: 'abe08370d1fcbb188064e2fc20abf5f7',
  contestHandovers: '9ac9b70b0f42d6f0f2f079df0e8437ce',
  contestHasInvoices: 'da0535723aa640de1eae01ebdd336341',
  contestInterestedFreelancers: '9e363880b10da1128e3a11f4087aa536',
  contestInvite: 'f06aea98eeae00234f7e734b108ba73c',
  contestMessages: '793706da59d59e3997256b454392a5b9',
  contestMinimumBudgetClassifications: '5927f1833074f51a601116d91011d5e1',
  contestPolls: 'd6f47e4b8b7db7c84efa7e82ce0a5b70',
  contestQuickviewEntries: '754bf9eb1014fb08d1b39d540e1d0749',
  contestViewContests: '392b342a39b8f8ad888686e0209dcb69',
  contestViewEntries: '07a46e2d28303abc31ab02763392d8a6',
  contestViewEntryIds: 'b158579a32ef41f4fb784ab7959ef002',
  contestViewNewOrUpdatedEntries: '62b044801e8c0866983e8371ee004aef',
  contestsSelfInsights: '6d4a26f1f9e583f35f315779173b83c0',
  contests: '507cadef6ed65d49213007809c500ff3',
  countries: 'd84355b6576cf5c6a700adf325033d34',
  currenciesIncludingExternal: '7de9b2df5bf61db45209b0276ae15363',
  currencies: '7de9b2df5bf61db45209b0276ae15363',
  currencyDetect: '7de9b2df5bf61db45209b0276ae15363',
  customFieldInfoConfigurations: 'ad5b0bf251e7b30f03c9fdf5bd8fd917',
  customFieldRelationships: '810cbd4f47fdec3dbeb9c8e153fe9c2a',
  customFieldValidations: 'e79943fdb22bc5ecec0ba6e630522e6a',
  dashboardPolls: '4a5ec8404c9cc72f492206255a087633',
  dashboardWidgets: 'f44fe0470085bb4eb64668a59db3ed6e',
  deloitteSubscriberEmails: '1c0091df229fdc72087ecdc965f702a0',
  deloitteUserInfo: '6f940769d6f4aad061a8ffae7ad86b63',
  depositFees: '3cd139c57da0d18a69e3d8f54f4c2078',
  depositPageVars: '8e3fa464297a43ec40c19f038fdba16a',
  developerApplications: '937e94bb45e2b2d0c548490d1e4237a9',
  developerTokens: 'ae77f04e1068b8e15782e70604eceda3',
  discoverCollectionItems: 'd49ecd957990be88a5c0146f9b819efc',
  discoverCollections: 'f3e5816f6210bed2525a5024155dd4ec',
  domains: 'c0e06272e05d594cf6702b5419ed5243',
  driveFilePermissions: 'c0cff6c7d2029832d4642533a723540d',
  driveFiles: '724a2a8039a094de4f884ff49b4df8e3',
  educations: '8e7f7e3d902633deb708d813bb61e9dc',
  emailIsAvailableForArrow: 'a0ddf5b621669626a62f47df472f3a87',
  employerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  encodedUrl: '44db17c46c57d7831b9e560e1613b31e',
  enterpriseContact: 'f9f4efad2b2f6589c7041036526d80a5',
  equipment: '401a6e037ec2892bf5110d5e3795d3a8',
  exams: 'a490e8e606bf16f4f0f200c31d54e47f',
  exchangeRates: '59143449e52559b3dd7e732c6037a2f7',
  experiences: '40986fee31964385e45bc33aef538cf7',
  feedMeta: '323584f7c5b242dc0c0f953eed117229',
  feedPosts: '3b9e3e90b9687cd1560b883238e0e59a',
  feed: 'dd5c9063680ab247e9ebd4c97b74b7f5',
  findPageDetails: '76fa2aef1ad9fcd364fd6ff2bd48e6ac',
  freelancerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  freelancerReputations: '3cebc056801046cf1be2c88ddc8d791d',
  globalFleetContact: 'bf1cb95f2ffd3b77a09962f62f2ffeab',
  grants: '20ff455821752fb9663d8e5132ecb5cf',
  groupMembers: 'e159c026c1da6115a27cbe0f120c99a6',
  groupPermissions: 'b0adfeee92b4ce5987c0c5b8eeebc4ef',
  groupsSelf: 'd196fb1dc315940d9dd5a009ec63fe04',
  groups: 'd196fb1dc315940d9dd5a009ec63fe04',
  hirePageDetails: 'a3a141ea92f526ed613c48d251765e6c',
  hiremeCounteroffers: '01f09946ca292605b754886da54f72cf',
  hourlyContracts: '81b362465ff0f0e19ee711f118ac5791',
  hourlyProjectMilestoneFees: '06d688f2a842f625af0fb0e8fa3c9b30',
  invoices: '51578ea5603d8772940b5b52f2230cf2',
  ipContracts: 'b4a6b468834bdbcf9db8cb825d8913f2',
  issuingInstitution: '191c5080a6cbb19009eb2935e758f46b',
  jobClassifier: '8d0cb74f449a0a11931133e83a9ad446',
  languageDetect: '8396cfb5cbcb3c8df3a922741007716c',
  languages: 'b5e1f3de9dae5b4c1526d475397a9bcd',
  manageViewContestHandovers: 'a3b556dc4211d4c5ed116fdf3758d1e9',
  manageViewContests: '73658c1dcba604e25a0fcf0898143e55',
  manageViewHandovers: '7f2e990b9cd16d1b98d88a3914a96df7',
  manageViewOngoingBids: '12f9cfe0cf7cf4a60dc8b94aa90e1f50',
  manageViewOngoingProjects: '63a21cc101b024eee487e884026d4f66',
  manageViewOpenBids: '972809a1c4e167e8d1e4ee36604d7ad7',
  manageViewOpenProjects: '143cf47582dc93622ae5b43c8a139ec1',
  manageViewPastBids: '4eebf38eb7730e8071a087e690d974cc',
  manageViewPastProjects: '55ca67f4157c61b89755450da0bc3eab',
  membershipBenefits: '1b3935953dfa7f6cad67f08a5e93380a',
  membershipDowngrades: '262ac51f00a02bd9f2920bb5ac4e6369',
  membershipPackagePrices: 'fa6e18fcf9dbc6654c1be4b8e3085d28',
  membershipPackages: '0593136eebe94e9ad4ebcdf6445e72e3',
  membershipRenewals: 'e357585dfa2f66ce9a1f79858a85bd95',
  membershipSale: '16c346ee31b81957b10f06af9bfdf999',
  membershipSubscriptionHistory: 'faffe2928580cdaa2cb3f91f6b3b67c4',
  membershipSubscription: 'e857bce84db7cabcdd1541e8b59d4c49',
  membershipTrials: 'ff61d0616faa339d81168e379fc03f70',
  messageAttachments: '651faffef24bfb290da9076ef4094f1e',
  messages: '6474bf43983c36a865ab299ca906c9b3',
  milestoneDrafts: 'f11b88854b984bd391b567b18c3af8ed',
  milestoneRequests: '4a03ed6f70c6e69c43377c1555c84e45',
  milestones: '44e6ba8e6ec559a5ebc3517b3174bb2a',
  modifyBidSellerFees: '403c3613ac89c1de9cf84c3c7455df3e',
  nativeExchangeRates: '59143449e52559b3dd7e732c6037a2f7',
  nearbyProjects: '7a4cca4f53eeccabb0aea8253192860d',
  newsfeed: '52bbbae264a76422ec0bd2d1ca889891',
  nextPreviousUsers: '84ead1aaa99dc711b4f7027f20a4ffc2',
  notificationsPreferences: '707e41567df79de7d3093d607f53368a',
  notifications: 'c0072b6f589e491b0e161ac28a5be70b',
  onBehalfProjects: 'de3c6b1524a43019b738c4d9512370cd',
  onlineOffline: 'c8e6e68cd993759dac49382b61a1ac64',
  paymentShareMembers: '35ab2fbfa6b4d4edcc079c7aabc8783e',
  paymentShareTeams: '64f9a8b36404caf1c2ef7290a1f9e7c6',
  pfSupportTickets: '1c736a0679b47a2f92fee2888149c236',
  pjpAssistantEnqueue: '9d60ace685ca5972b1967be2059d8bcc',
  portfolios: 'f799d42650b7c33019da0f98866b1c05',
  postFiles: 'f226d954dbdecb6da37be039cbfd512d',
  postJobPageFormState: 'a6e5b19398d5961973831c94c46ee465',
  predictedSkills: '724d5f18f98df47a7253837e1d03c9a6',
  preferredBillingAgreements: '0916f85b4037cc0d45be67638b04a50d',
  profileCategories: '6e2e5dd8262e1e3a576a232c5d674ada',
  profileViewUsers: '815024dffd3516569339e582319ee073',
  projectBidInfo: '351b3202fd35e960e123f916b4cb4166',
  projectBookmarks: '94b358c99f7d89310f719640a163581c',
  projectBudgetOptions: 'fe3aa365c616fb43e1da48afcc2f130d',
  projectCollaborations: '47de2c84d4c059dbd46a9e54f2e8b465',
  projectFeeInfo: '141ae845bb7bcbec6f8b1c39d825b7f2',
  projectFeedFailingContests: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectFeedFailingProjects: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectFeed: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectInvite: 'd88f62eaadcb2ebd35a51e815efbf160',
  projectOffer: '7f26ad3000909c270de718570960cc58',
  projectStats: '8e9564d27a9cf6292176258ed367e68b',
  projectUpgradeFees: 'db52110a10b8adcad820b38f42b9a24a',
  projectViewBidderLocations: '9e6f9adddc0cee3e33ed118a8ac34b75',
  projectViewBids: '814f38c148b82a9764245ddf997e1169',
  projectViewProjects: '0dc9ab60b11c561dc7799ab3436b3086',
  projectViewUsers: 'de6d5c227e4cdca17560cc0a2ef6236c',
  projectsSelfInsights: '811ba7045bc5d3f1c9f6e70e58f0dfe3',
  projects: '69da2ddf8224316fa91f75b7a9ea1e5c',
  publications: '32798a1bbd15853ddb6ec4f76fa43f97',
  recommendedMembership: '136b2dc1686addd12e396cc73176828a',
  recommendedUsernames: 'c1730888439c6e53b0b7c05b9e7edef2',
  recruiterOptOut: 'f7106ebbf3e60c1a6fa980bcf70ae004',
  referralInvitationCheck: '24eddef86909e002dd9ee8cded56f8d2',
  referralInvitations: '61348e34ac68a8f8c437f8d0f33eddf9',
  reviewsSkills: '0fa5a9706cd3dde5679039085018d7de',
  reviews: '881afe171953fd4ebeafd59099bc4c8a',
  searchActiveContests: '9a51a24e0985effb70044175cfc75976',
  searchActiveProjects: 'cb4a0f08222af7d5cad6615fd928739c',
  searchAllProjects: '69da2ddf8224316fa91f75b7a9ea1e5c',
  searchContestEntrants: '16c81d21c56d0f1b5ec1929be770feae',
  searchContestEntries: '07a46e2d28303abc31ab02763392d8a6',
  searchContests: '4eecae75511f66bd3a1d7abbad095059',
  searchFreelancers: '59790ae02045d1b1a8fcd4eb0284fd9d',
  searchHistory: '7a826dfd6e549968829c4e407125bb5d',
  searchKeywordProjects: '1f5af6a224fb12cd6c5bebf038916efe',
  searchMyContacts: 'e62414e4cf126c78a96d0bd3b10ac132',
  searchMyProjectsBuyer: 'c1c4c45e381ac26d2254b5cb5afa7f23',
  searchProjectsSelf: 'e3cf76608cb456162809f92b333928f5',
  searchThreads: 'fc49e3d3e50dd95ea380cc8d924aa436',
  searchUsers: '4373f2bd7a19fdd1340a3db94aedc6f0',
  showcaseSource: '528a53ba8ced968954a3585a5225a22c',
  showcase: 'a423817f39ff390fb08861528feb0ba6',
  similarFreelancers: 'a94c2497773696df7c26be74e2ff7530',
  similarShowcases: 'a94c2497773696df7c26be74e2ff7530',
  siteStats: '95a8af1926677fb0ed9b8a1de744dd5d',
  skillBundles: 'd00f17bc6add44c135e16d1641a0d65f',
  skillsSubNavigation: 'b53931bf59b48506b398c94c42f675a7',
  skills: 'b0b9d47616e234db600127beb4ebf884',
  suggestedSkills: '74db00b149426fa76661ddd86621e02d',
  superuserAgentSessions: '33cd2c64dafbae9a9d94f85febee0490',
  superuserBids: 'acb50dcac2299e47945d9a727bac1026',
  superuserMessages: '6474bf43983c36a865ab299ca906c9b3',
  superuserMilestones: '44e6ba8e6ec559a5ebc3517b3174bb2a',
  superuserProjectCollaborations: '47de2c84d4c059dbd46a9e54f2e8b465',
  superuserProjectViewProjects: '0dc9ab60b11c561dc7799ab3436b3086',
  superuserProjectViewUsers: '20e277abb5694b5ba49048366cc13ec1',
  superuserSearchThreads: '31d0eca5cadc85df4899a966e7ac33bf',
  superuserThreads: '31d0eca5cadc85df4899a966e7ac33bf',
  tagFamilyMembers: 'bec8b904ff3c95ce66f8f068ad560215',
  tagProperties: 'c921ffb9aa46d085b4828622489c8d71',
  tags: 'bcf4ea4b24fd7c420e375e6a3e865817',
  tasks: '01c5cb8d0996464fe2f088daf4d4e359',
  tax: '269061e1c3f348f62dbd36fd55f74e0f',
  teamMembers: 'bb6a0e0816be6616cd7e94e9d7cb3386',
  teams: '2683231453ddb11b5b8781fbae14592a',
  threadProjects: '1a5f754b9203c61124063d98bf6f5050',
  threads: 'fc49e3d3e50dd95ea380cc8d924aa436',
  timeTrackingDailyAggregates: 'cf0b1a2d3b1818f710fd8b075d328e75',
  timeTrackingPunches: '978a2c023ab70576f2d3630e89ced002',
  timeTrackingSessionAggregate: 'c21f646077e99cb71252ac21e55dab7e',
  timeTrackingSession: '80a6c6bc3554ed72d60b21f37512b918',
  toastNotifications: '96b443d81fd6f40196297ffb53e31399',
  topSkills: '88edbb1b65d6031c7e16fea85f5e9c86',
  tracks: 'e432997983ba0bedffd22d84f0d1e939',
  transactionHistoryDetails: '2c9bcefdc7a6d4094ed734f28c4ca093',
  transactionHistoryItems: '584221b11640fef828f038a3bcd4d357',
  twoFactorDetails: 'bf5a516c4382437117e334903aaeae3c',
  universities: '6864ec0a4d30b810ff1df4e3433ea339',
  usStates: 'f251a17954a572d64b9400e2e94b9ded',
  userBalances: 'ac222b4645e3d514e8b493905d12f8f1',
  userBidLimit: '02e82788a8467ff18539b987ac7227b6',
  userCalifornianStatuses: '811b21828faa5a88aee50fa30d9cfc63',
  userDepositMethods: '4d30d62dc105f3b498f4e18d6abe49f5',
  userFees: '19b4431c8edc85e0696c2e9345a70905',
  userGiveGetDetails: 'd111cdcfd30887f43734ba920b81f71e',
  userHasGivenFeedback: '9da27991064a86ae00666fdfb61bf052',
  userInfo: 'ac33e1ef1f73db03ae8799221338deb2',
  userInsignias: 'e393f744166ee2426b598923634c9f7e',
  userInteractions: 'b69a5eaa43726f0eae83d0348f44abf6',
  userIsArrowWhitelisted: 'd57f78c922d51723060e1b7efc222273',
  userNps: '4cbf9dfa2ab3c351d16e8489d8977f8d',
  userOnPaytmMembershipPlan: '41cbb1f644ef5ec65b4c7216aac23311',
  userPendingFunds: 'af370a4b7c2adb028a666297aa9ffa28',
  userRecentProjectsAndContests: 'ea394addcb61da312db4ff899767f57d',
  userRequiresEmailVerification: 'e2f0beae240a0912172c652af0c3eb4e',
  userRequiresGdpr: '1f1923492a3b9ecbd2ce5b3c9c9d1b28',
  userSkills: 'e25b853ca911f12c0be653aa7a70b706',
  userTypeInfo: '946dad862050d0198174c3380eb7e91f',
  usersFollow: 'bbea0e01511c4dca66ded193ee07fca0',
  usersLocation: 'f1090c0bbe736a555d0159e23e8c32c6',
  usersProfileImage: 'e97d332d6bb3ee806476de0483c34df7',
  usersProfile: '6d6dcefe9d1d9a3f2feb691ede57dea8',
  usersRecommend: '0a80e5d13a75c26e4e765d9042d3acb6',
  usersSelf: 'abe67753caa7be364ba6a2e2e578b553',
  users: '4b025bdc2a1a59472773f333bc84220b',
  verificationAddressDocumentTypes: 'd13b03dc042b753ecea9437010ac4ff8',
  verificationFiles: '95b77192f8e35b2ccc158a8d494b723d',
  verificationIdTypes: '70151aa0c0c75979b269082909b8bf3f',
  verificationRequest: 'f9366dfbb548d1eb4b03504af4bc6914',
  violationReports: 'dba92b71477988f2a8017329ccbfe155',
  webhooks: 'cada0b9dbf7f2dedb9f053882b7d0f87',
};
